@layer module {
.icon-letter {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            border-radius: 50%;
    }
} // layer module










@layer app {
.merchant-switch-menu-wrapper {
            margin: 0 $size-10;
    }

.merchant-switch-menu-wrapper.hamburger {
            margin: 0;
    }

.icon-letter {
            margin: 0;
            width: $size-28;
            height: $size-28;
    }

.menu-container {
            gap: $size-8;
    }

.menu-dropdown {
            min-width: $size-200;
    }

.icon-letter {
            background-color: var(--merchant-switch-avatar-background);
            color: var(--banky-white);
            font-size: var(--font-size-base);
            font-weight: 400;
    }

.icon-letter.active {
            background-color: var(--merchant-switch-avatar-active-background);
    }
} // layer app
